export const softText = [
    "Mitrahsoft NodeJS development team can help you build a realtime node.js application efficiently and with top quality. We have a team of Expert ExpressJS, HapiJS, KoaJS and other NodeJS Framework developers. We are talented, integrated team that delivers experiences with extreme Node.Js performance and optimization. Node.Js Connect's team is ready for complex migrations, deployment support.",
    "Our team of developers with vast experience, have developed NodeJS applications integrated with major database platforms such as MySQL, NoSQL, MongoDB, PostgreSQL etc.",
    "Our NodeJS team is ready for complex migrations, deployment support, help to build great products with faster time and we help in scaling the application features."
]
export const list = [
    "Node.JS REST API development",
    "Node JS Application Development",
    "App Integration and Deployment",
    "Node JS Migration",
]
export const list2=[
    {
        ul: [
            {li: "ReactJS development",
            path: "services/reactjs-development"},
            {li: "VueJS development",
            path: "/services/vuejs-development"},
            {li: "AngularJS development",
            path: "/services/angular-development"},
            {li: "Angular development",
            path: "/services/angular-development"},
            {li: "D3.JS Data Visualization",
            path: "/"},
            {li: "React Native Mobile App Development",
            path: "/services/reactjs-development"},
        ]
    }
]
export const list3 = [
    "Supply Chain Management System",
    "Retail & E-Commerce",
    "Education",
]
export const dualList1 = [
    {
        listHead: "Query Language & Database:",
        ul: [
            { li: "GraphQL:" },
            { li: "MySQL:" },
            { li: "Firebase:" },
            { li: "MongoDB:" },
            { li: "NoSQL:" },
            { li: "PostgreSQL:" },
            { li: "Oracle:" },
            { li: "MS-SQL:" },
        ]
    }
]
    export const dualList2=[ {
        listHead: "Object Modeling Tool:",
        ul: [
            { li: "Mongoose:" },
            { li: "Sequelize" },
            { li: "Waterline" }
        ]
    },
    {
        listHead: "Version control & Project Tracking Tools:",
        ul: [
            { li: "GIT" },
            { li: "Atlassian JIRA" },
            { li: "Trello" },
        ]
    }
]
export const dualList3=[
    {
        listHead: "Test Driven Development Tools:",
        ul: [
            { li: "Mocha" },
            { li: "Jasmine" },
            { li: "Chai" },
            { li: "Shouldjs" },
        ]
    },
  
    {
        listHead: "Task Runner:",
        ul: [
            { li: "Grunt" },
            { li: "Gulp" },
            { li: "Bower" },
        ]
    },

]
export const nodeJS1 = [
    "Nodejs1",
    ]
export const nodeJS2 = [
    "Nodejs2",
    ]
        
export const nodeJS3 = [
    "Nodejs3",
    ]